<template>
  <div class="custom-datepicker-shell" :dir="pickerDirection">
    <VueDatePicker
      :model-value="modelValue"
      @update:model-value="handleUpdate"
      :range="range"
      :enable-time-picker="enableTimePicker"
      :clearable="clearable"
      :format="dateFormat"
      :preview-format="dateFormat"
      :placeholder="placeholder"
      :auto-apply="autoApply"
      :multi-calendars="multiCalendars"
      :locale="pickerLocale"
      :position="menuPosition"
      :auto-position="true"
      teleport="body"
      class="w-full custom-datepicker-style"
      :class="pickerDirection === 'rtl' ? 'custom-datepicker-style-rtl' : 'custom-datepicker-style-ltr'"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { globalState } from '@/globalState';
import { useI18n } from '@/i18n';

const props = defineProps({
  modelValue: {
    type: Array,
    required: true,
  },
  range: {
    type: Boolean,
    default: true,
  },
  enableTimePicker: {
    type: Boolean,
    default: false,
  },
  clearable: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: 'Select date range',
  },
  autoApply: {
    type: Boolean,
    default: true,
  },
  multiCalendars: {
    type: [Boolean, Object],
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);
const { currentLanguage } = useI18n();

const isRtl = computed(() => {
  const lang = String(currentLanguage.value);
  if (lang === 'he') {
    return true;
  }
  if (lang === 'ar') {
    return true;
  }
  return false;
});

const pickerDirection = computed(() => {
  if (isRtl.value === true) {
    return 'rtl';
  }
  return 'ltr';
});

const menuPosition = computed(() => {
  if (isRtl.value === true) {
    return 'right';
  }
  return 'left';
});

const pickerLocale = computed(() => {
  const lang = String(currentLanguage.value);
  if (lang === 'he') {
    return 'he';
  }
  if (lang === 'ar') {
    return 'ar';
  }
  return 'en';
});

const dateFormat = computed(() => {
  const timezone = globalState.orgSettings?.timezone;
  if (timezone === 'Asia/Jerusalem') {
    return 'dd/MM/yyyy';
  }
  return 'MM/dd/yyyy';
});

const handleUpdate = (newValue) => {
  emit('update:modelValue', newValue);
};
</script>

<style scoped>
.custom-datepicker-shell {
  width: 100%;
}

.custom-datepicker-style {
  width: 100%;
}

.custom-datepicker-style :deep(.dp__main),
.custom-datepicker-style :deep(.dp__input_wrap),
.custom-datepicker-style :deep(.dp__input) {
  width: 100%;
}

.custom-datepicker-style :deep(.dp__input_wrap .dp__input) {
  height: 3rem;
  border-color: #d1d5db;
}

.custom-datepicker-style-rtl :deep(.dp__input_wrap .dp__input) {
  text-align: right;
  direction: rtl;
}

.custom-datepicker-style-ltr :deep(.dp__input_wrap .dp__input) {
  text-align: left;
  direction: ltr;
}
</style>

<style>
.dp__outer_menu_wrap {
  z-index: 10050 !important;
}
</style>
